/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Permission_Badge_VerifyInputs */

const en_agent_authorization_permission_badge_verify = /** @type {(inputs: Agent_Authorization_Permission_Badge_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the deployed project for the approved badge and backlink`)
};

const zh_agent_authorization_permission_badge_verify = /** @type {(inputs: Agent_Authorization_Permission_Badge_VerifyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`检查线上项目中的已授权徽章和反链`)
};

/**
* | output |
* | --- |
* | "Check the deployed project for the approved badge and backlink" |
*
* @param {Agent_Authorization_Permission_Badge_VerifyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_permission_badge_verify = /** @type {((inputs?: Agent_Authorization_Permission_Badge_VerifyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Permission_Badge_VerifyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_permission_badge_verify(inputs)
	return zh_agent_authorization_permission_badge_verify(inputs)
});
export { agent_authorization_permission_badge_verify as "agent.authorization.permission.badge_verify" }